import Parse from "parse";
import debug from "src/modules/debug-logger";
import clearParseSession from "../clearParseSession";
import getUserSubscription from "./getUserSubscription";

export async function signUp({ familyName, email, password }) {
  const { sessionToken } = await Parse.Cloud.run("signUp", {
    familyName,
    email,
    password
  });
  await clearParseSession();
  const parseUser = await Parse.User.become(sessionToken);
  const user = parseUser.toJSON();
  return user;
}

export async function logInWithOtp({ xmppLogin, authId, otp }) {
  const { sessionToken } = await Parse.Cloud.run("logInWithOtp", {
    xmppLogin,
    authId,
    otp
  });
  await clearParseSession();
  const parseUser = await Parse.User.become(sessionToken);
  const user = parseUser.toJSON();
  user.subscription = await getUserSubscription();
  return user;
}

export async function signInAsAnonymousUser(xmppLogin) {
  await clearParseSession();
  debug.auth("Creating anonymous account for xmppLogin:", xmppLogin);
  const { sessionToken } = await Parse.Cloud.run("createAnonymousAccount", {
    xmppLogin
  });
  const parseUser = await Parse.User.become(sessionToken);
  const user = parseUser.toJSON();
  return user;
}

export function generateOtp() {
  return Parse.Cloud.run("generateOtp");
}

export async function updateUser(update) {
  const parseUser = await Parse.User.current().save(update);
  const user = parseUser.toJSON();
  user.subscription = await getUserSubscription();
  return user;
}

export async function fetchCurrentUser() {
  let parseUser = Parse.User.current();
  if (parseUser == null) {
    return null;
  }

  parseUser = await Parse.User.become(parseUser.get("sessionToken"));
  const user = parseUser.toJSON();
  user.subscription = await getUserSubscription();
  return user;
}

export async function logIn({ xmppLogin, username, password }) {
  const { sessionToken } = await Parse.Cloud.run("logIn", {
    xmppLogin,
    username,
    password
  });
  await clearParseSession();
  const parseUser = await Parse.User.become(sessionToken);
  const user = parseUser.toJSON();
  user.subscription = await getUserSubscription();
  return user;
}

export async function signOut(xmppLogin) {
  const { sessionToken } = await Parse.Cloud.run("signOut", { xmppLogin });
  await clearParseSession();
  const parseUser = await Parse.User.become(sessionToken);
  return parseUser.toJSON();
}

export async function deleteAccount({ xmppLogin, email, password }) {
  const response = await Parse.Cloud.run("deleteAccount", {
    xmppLogin,
    email,
    password
  });
  await clearParseSession();
  return response;
}

export async function getCloudSettings() {
  const settings = await Parse.Cloud.run("getCloudSettings");
  return settings;
}

export async function updateCloudSettings(updatedParams) {
  const response = await Parse.Cloud.run("updateCloudSettings", {
    updatedParams
  });
  return response;
}
